exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
var urlEscape = require("../../../../../node_modules/css-loader/dist/runtime/url-escape.js");
var ___CSS_LOADER_URL___0___ = urlEscape(require("@tencent/docs-design-resources/pc/svg/copypaste_format.svg"));
var ___CSS_LOADER_URL___1___ = urlEscape(require("@tencent/docs-design-resources/pc/svg/toolbar_pulldown.svg"));

// Module
exports.push([module.id, ".index-paste-special-panel-2jmG5{position:absolute;background:#fff;border-radius:4px;border:1px solid rgba(0,0,0,.12);width:40px;height:28px;display:flex;justify-content:center;align-items:center;z-index:999}.index-paste-special-panel-clicked-3miaS{background:#ebebeb}.index-btn-wrapper-25mkG{display:flex;align-items:center;justify-content:center}.index-file-1NcKa{background-image:url(" + ___CSS_LOADER_URL___0___ + ");background-size:18px 18px;width:18px;height:18px}.index-arrow-3EPYU{width:10px;height:10px;background-image:url(" + ___CSS_LOADER_URL___1___ + ");background-size:10px 10px}", ""]);

// Exports
exports.locals = {
	"paste-special-panel": "index-paste-special-panel-2jmG5",
	"paste-special-panel-clicked": "index-paste-special-panel-clicked-3miaS",
	"btn-wrapper": "index-btn-wrapper-25mkG",
	"file": "index-file-1NcKa",
	"arrow": "index-arrow-3EPYU"
};